/**
 * desc_like: いいね順
 * asc_created: コメントの作成日(昇順)
 */
export const COMMENT_LIST_SORT_TYPE_LIST = [
  'desc_like',
  'asc_comment_created',
] as const

export type CommentListSortType = typeof COMMENT_LIST_SORT_TYPE_LIST[number]

export const COMMENT_LIST_SORT_TYPE_LOCAL_STORAGE_KEY = 'comment_list_sort_type_local_storage_key'
